export default function (obj, ...args) {
  return args.reduce((obj, level) => obj && obj[level], obj);
}

// console.log(getNestedValue(test, 'level1', 'level2', 'level3')); // 'level3'
// console.log(getNestedValue(test, 'level1', 'level2', 'level3', 'length')); // 6
// console.log(getNestedValue(test, 'level1', 'level2', 'foo')); // undefined
// console.log(getNestedValue(test, 'a', 'b')); // undefined
